export default __webpack_public_path__ + "static/media/serum_hilic.3af04fc7.png";